import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthFooterLink from './AuthFooterLink';

const COUNTDOWN_SECONDS = 30;

export interface ResendButtonProps {
  onResend: () => void;
}

export default function ResendButton({ onResend }: ResendButtonProps) {
  const { t } = useTranslation('auth');
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) return;
    const interval = window.setInterval(() => {
      setSecondsLeft((s) => Math.max(0, s - 1));
    }, 1000);
    return () => window.clearInterval(interval);
  }, [secondsLeft]);

  const handleClick = () => {
    onResend();
    setSecondsLeft(COUNTDOWN_SECONDS);
  };

  if (secondsLeft > 0) {
    return (
      <AuthFooterLink disabled aria-live="polite">
        {t('common.resend_in', { seconds: secondsLeft })}
      </AuthFooterLink>
    );
  }

  return <AuthFooterLink onClick={handleClick}>{t('common.resend_code')}</AuthFooterLink>;
}
